import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import React from 'react';
import { CheckboxFieldType } from '@/type';
import { useTranslation } from 'react-i18next';

interface CheckboxInputProp {
  field: any;
  checkboxField: CheckboxFieldType;
}

const CheckboxInput = ({ field, checkboxField }: CheckboxInputProp) => {
  const { t } = useTranslation();
  return (
    <FormControl fullWidth>
      <FormControlLabel
        labelPlacement='end'
        control={
          <Checkbox
            id={field.name}
            {...field}
            required={checkboxField.required}
            checked={!!field.value}
            disabled={checkboxField.disabled}
            onChange={(e) => {
              const value = e.target.checked;
              field.onChange(value);
              checkboxField.onChange?.(value);
            }}
          />
        }
        label={t(checkboxField.label)}
      />
    </FormControl>
  );
};

export default CheckboxInput;
